import { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { dataLoad } from "../data/storeAction";
import { Shop } from "./Shop";
import { addToCard, removeFromCard } from "../data/CartActions";
import CartDetials from "./CartDetials";
import { Link } from "react-router-dom";

const mapStateToProps = (storeData) =>{
  return{user:storeData.shopReducer, cart: storeData.CartReducer}
}

const mapDispatchProps = {dataLoad, addToCard, removeFromCard}

const filterProducts = (all_products = [], category)=>
  ( !category)? all_products : all_products.filter(i=> i.category === category)

class  Connector extends Component{  
  
  render(){
    return(<div className="w-screen h-screen relative">
      <div className="bg-white pt-3 flex justify-around items-center sticky top-0 z-50">
        <div>menu</div>
        <h1 className="text-xl tracking-wider">DEPOT</h1>
        <div className="flex text-[12px] gap-2">
          <Link to="/shop/cart">CART({this.props.cart.cartItems || 0})</Link>
        </div>
      </div>
      <Switch>
        <Route path="/shop/products/:category?" render={(routeProps)=><Shop {...this.props} {...routeProps} pro={ filterProducts(this.props.user.products,routeProps.match.params.category)}/>}></Route>
        <Route path="/shop/cart" render={(routeProps)=><CartDetials {...this.props}/>}></Route>
        <Redirect to="/shop/products"/>
      </Switch>
      <p className="px-10 text-slate-600 text-sm">CopyRight Themes</p>
    </div>
    )
  }

  componentDidMount(){
    console.log(this.props.user);
    this.props.dataLoad();
  }
}

export const ShopConnector = connect(mapStateToProps, mapDispatchProps)(Connector)